export { default } from './DesktopSlider';
